import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase";

const C = {
    bg: "#ffffff", surface: "#f7f7f7", border: "#e0e0e0",
    text: "#000000", muted: "#555555", accent: "#52658F", peach: "#ECDBC9",
};
const SYNE = "'Fraunces', serif";
const MONO = "'Plus Jakarta Sans', sans-serif";
const FONT_LINK = "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,700;9..144,800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap";

export default function ResetPasswordPage() {
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (!document.querySelector('link[href*="Fraunces"]')) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = FONT_LINK;
            document.head.appendChild(link);
        }
        supabase.auth.onAuthStateChange((event) => {
            if (event === "PASSWORD_RECOVERY") {
                // User is now in password recovery mode — show the form
            }
        });
    }, []);

    async function handleReset() {
        if (password !== confirm) { setError("Passwords don't match."); return; }
        if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
        setLoading(true);
        setError(null);
        const { error } = await supabase.auth.updateUser({ password });
        if (error) {
            setError(error.message);
        } else {
            setDone(true);
            setTimeout(() => navigate("/app"), 2000);
        }
        setLoading(false);
    }

    const inputStyle = {
        width: "100%", background: "#ffffff", border: "1.5px solid " + C.border,
        borderRadius: 8, padding: "0.75rem", color: C.text,
        fontFamily: MONO, fontSize: "0.9rem", outline: "none", boxSizing: "border-box",
    };

    return (
        <div style={{ background: C.bg, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: MONO, padding: "2rem" }}>
            <div style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 16, padding: "2.5rem", width: "100%", maxWidth: 380, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>

                <img
                    src={require("../assets/dgb-logo-light.png")}
                    alt="DGB"
                    style={{ height: 64, cursor: "pointer", marginBottom: "1.5rem", display: "block" }}
                    onClick={() => navigate("/")}
                />

                <h2 style={{ fontFamily: SYNE, fontWeight: 800, fontSize: "1.4rem", color: C.text, marginBottom: "0.4rem", letterSpacing: "-0.02em" }}>
                    Reset your password
                </h2>
                <p style={{ color: C.muted, fontSize: "0.85rem", marginBottom: "1.75rem", lineHeight: 1.6 }}>
                    Enter a new password for your account.
                </p>

                {done ? (
                    <div style={{ color: "#059669", fontSize: "0.9rem", textAlign: "center", padding: "1rem 0" }}>
                        ✓ Password updated. Redirecting...
                    </div>
                ) : (
                    <>
                        <input
                            type="password"
                            placeholder="New password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            onKeyDown={e => e.key === "Enter" && handleReset()}
                            style={{ ...inputStyle, marginBottom: "0.75rem" }}
                            onFocus={e => e.target.style.border = "1.5px solid " + C.accent}
                            onBlur={e => e.target.style.border = "1.5px solid " + C.border}
                        />
                        <input
                            type="password"
                            placeholder="Confirm new password"
                            value={confirm}
                            onChange={e => setConfirm(e.target.value)}
                            onKeyDown={e => e.key === "Enter" && handleReset()}
                            style={{ ...inputStyle, marginBottom: "1rem" }}
                            onFocus={e => e.target.style.border = "1.5px solid " + C.accent}
                            onBlur={e => e.target.style.border = "1.5px solid " + C.border}
                        />
                        {error && (
                            <div style={{ color: "#dc2626", fontSize: "0.8rem", marginBottom: "0.75rem" }}>⚠ {error}</div>
                        )}
                        <button
                            onClick={handleReset}
                            disabled={loading}
                            style={{ width: "100%", background: loading ? C.border : C.accent, color: loading ? C.muted : "white", border: "none", padding: "0.8rem", borderRadius: 8, fontFamily: SYNE, fontWeight: 700, fontSize: "0.95rem", cursor: loading ? "not-allowed" : "pointer" }}>
                            {loading ? "Updating..." : "Update Password"}
                        </button>
                    </>
                )}

                <button onClick={() => navigate("/")}
                    style={{ width: "100%", background: "transparent", border: "none", color: C.muted, fontSize: "0.8rem", cursor: "pointer", fontFamily: MONO, marginTop: "1rem" }}>
                    ← Back to home
                </button>
            </div>
        </div>
    );
}
